<template>
  <b-container fluid class="top-padding bottom-padding no-horiz-padding">
    <h2>Introducing the Draft Color Editor</h2>
    <div>
      <p>
        We are pleased to offer the Draft Color Editor, where you can <span style='font-weight: bold'>instantly apply different colors to any Handweaving.net draft or to your own drafts!</span>
      </p>
      <ul>
        <li>Have you ever woven something where the colors were not great?</li>
        <li>Would you like to be able to see what a draft would look like with yarns you already have?</li>
        <li>Do you want to try out different colors entirely or just on certain threads for a draft?</li>
        <li>Have you ever wanted to create fabric that conveys the essence of a photo by using some of its colors?</li>
      </ul>
    
      <p>
         The Draft Color Editor can help with all of these things and more!
         Watch the <a href='https://youtu.be/EeR1GNLPXjk' target='_blank'>video demo</a> (6 minutes) or look through 
         the <a href='/draft-editor-instructions'>instructions page</a> to learn to use this quickly.
      </p>
      
      <div style='margin-top: 1rem'>
        <b-button variant='primary' size='sm' target='_blank' href='https://youtu.be/EeR1GNLPXjk'>Video Demo »</b-button>
        <b-button variant='primary' size='sm' to='/draft-editor-instructions'>Instructions »</b-button>
        <span style='font-weight: bold'>Try out the Draft Color Editor below with a preloaded sample draft!</span> 
      </div>
      <hr>
      <div v-if='((!isAuthenticated) || (!isSubscriber))'>
        <h2>Handweaving.net Subscriptions</h2>
        <ul>
          <li>The Draft Color Editor is available to Handweaving.net subscribers.</li>
          <li>Your subscription provides access to nearly 70,000 historic weaving drafts to use with the Color Editor, and 
            to view, download, and print.</li>
          <li>We also provide thousands of scanned historic weaving documents.</li>
          <li>Your subscription helps to support the continuation and expansion of Handweaving.net for all!</li>
        </ul>
        <b-button variant='primary' size='sm' to='/subscription'>Subscribe Now »</b-button>
        <b-button variant='primary' size='sm' to='/subscription'>Learn More »</b-button>
        <hr>        
      </div>
      <iframe :src='getDraftEditorUrl' :style='getIframeStyle()'/>
    </div>
  </b-container>
</template>

<script>

import mediaService from '../mixins/mediaService.js'
export default {
    mixins: [mediaService],
    methods: {
        getDocHeight() {
            let doc = document
            // stackoverflow.com/questions/1145850/
            let body = doc.body
            let html = doc.documentElement
            let height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight, window.innerHeight)
            return height
        },
        getIframeStyle() {
            let style='border: none; width: 100%; height: ' + this.getDocHeight() + 'px;'
            // console.log('iframe style: ' + style)
            return style
        }
    },
    components: {
    },
    computed: {
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },
        authUser: function() {
            return this.$store.state.authUser
        },
        isAuthenticated: function() {
            let val=this.$store.getters.isAuthenticated
            // console.log('in isAuthenticated, returning ' + JSON.stringify(val))
            return val
        },
        getDraftEditorUrl: function() {
            let url = window.location.origin + '/draft-editor'
            url += '?embed=true'
            url += '&noupload=true'
            url += '&size=11'
            url += '&file=https%3A%2F%2Fs3.amazonaws.com%2Fkb.public.items%2Fcolor-editor-samples%2F44335.wif'
            return url
        }
    },
    created() {
        this.$store.commit('setPageTitle', 'Draft Color Editor Introduction')
    }
}
</script>

<style scoped>
.maxLogoHeight {
    max-height: 90px;
    height: 90px;
}


img {
  max-width: 50%;
  margin-top: 1rem;
  margin-bottom: 1rem
}

.top-margin {
  margin-top: 1rem;
}

li {
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/DraftEditorIntroduction.vue